import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import FiltersState from './filters.state';

const initialState = FiltersState;

export const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    SET_RES_REQ_FILTERS: (state, action: PayloadAction<Partial<FiltersStateType['resReq']>>) => {
      state.resReq = { ...state.resReq, ...action.payload };
    },
    SET_USERS_FILTERS: (state, action: PayloadAction<Partial<FiltersStateType['users']>>) => {
      state.users = { ...state.users, ...action.payload };
    },
    SET_ORG_FILTERS: (state, action: PayloadAction<Partial<FiltersStateType['organization']>>) => {
      state.organization = { ...state.organization, ...action.payload };
    },
  },
});

export default filtersSlice.reducer;
